import React from 'react';
import ProjectDetailView from 'components/ProjectDetailView/ProjectDetailView';
import epflData from './data';

const EPFL = () => {
  return <ProjectDetailView data={epflData} />;
};

export default EPFL;
